import acordeon from "./acordeon";
import galeria from "./galeria";

require('../sass/app.scss');

galeria();
acordeon('.acordeon');